<form #observationForm="ngForm">
  <div class="row">
    <div class="col">
      <!--<div class="row">
        <div class="col">
          <app-eca-input [(value)]="selectedObservationType" [controlId]="'ctrlObservationType'"
                         [isReadOnly]="true"
                         [popoverText]="'Observation Type'"
                         [isRequired]="true"
                         [isValid]="!saveAttempted || !!observation?.observationType"
                         [validationMessage]="'Please enter observation type.'"
                         [label]="'Observation Type'">
          </app-eca-input>
        </div>
      </div>-->
      <div class="row">
        <div class="col">
          <app-eca-input [(value)]="observation.observedBy" [controlId]="'ctrlObservedBy'"
                         [isReadOnly]="!isEditing"
                         [popoverText]="'Observed By'"
                         [isRequired]="true"
                         [isValid]="!saveAttempted || !!observation?.observedBy"
                         [validationMessage]="'Please enter observer name.'"
                         [label]="'Observed By'">
          </app-eca-input>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <app-eca-input [(value)]="observation.summaryInfo" [controlId]="'ctrlSummaryInfo'"
                         [isReadOnly]="!isEditing"
                         [popoverText]="'Summary Info'"
                         [isValid]="!saveAttempted || !!observation?.summaryInfo"
                         [validationMessage]="'Please enter summary information for this observation.'"
                         [isRequired]="true"
                         [label]="'Summary'">
          </app-eca-input>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <app-eca-date-picker [isDisabled]="!isEditing" [controlId]="'ctrlDateObserved'" (dateValueChange)="disableDatesPriorSelected(observation.observedOn)"
                                 label="Observed On"
                                 [maxDate]="observedOnMaxDate"
                                 [(dateValue)]="observation.observedOn"
                                 [isRequired]="true"
                                 [isValid]="!saveAttempted || !!observation?.observedOn?.dateTime"
                                 validationMessage="Please enter the date the record was observed"
                                 popoverText="Please enter the date that this was observed on.">
            </app-eca-date-picker>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <app-eca-date-picker [isDisabled]="!isEditing || observation?.observedOn?.dateTime === undefined || observation?.observedOn?.dateTime === null" [controlId]="'ctrlDateFollowUp'"
                                 label="Follow Up On"
                                 (dateValueChange)="setDateLimits()"
                                 [minDate]="followUpMinDate"
                                 [(dateValue)]="observation.followUpOn"
                                 [isRequired]="false"
                                 validationMessage="Please enter the date the record was observed"
                                 popoverText="Please enter the follow up date.">
            </app-eca-date-picker>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <app-eca-html-editor [(content)]="observation.notesAsHtml"
                                 [isReadOnly]="!isEditing"
                                 [popoverText]="'Observation Notes'"
                                 [isRequired]="false"
                                 [label]="'Notes'"
                                 [placeHolder]="'Enter note details'"
                                 (contentChange)="observation.notesAsHtml"></app-eca-html-editor>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
